$(function () {
  onclickcolor();
  masterPromo();
  swapprodvar();
  embroiderySectionInit();
  //detectLocationByIP();
  triggerPreOrderButton();
});

window.detectLocationByIP = async () => {
  try {
    // Check if server-side location detection is available
    // This is the preferred method and avoids API rate limits
    if (window.shippingRegion || window.userCountry) {
      const country = window.shippingRegion || window.userCountry;
      const isSingapore = window.isSingapore === true || country === 'Singapore' || country === 'SG';
      
      console.log('Using server-side location detection:', country);
      
      // Apply the appropriate shipping bar styles
      if (isSingapore) {
        $('.shipping-css').append(`<style>.singapore-free-shipping-bar { display: block; }</style>`);
      } else {
        $('.shipping-css').append(`<style>.singapore-free-shipping-bar { display: none; }</style>`);
      }
      
      return {
        country: country,
        countryCode: country === 'Singapore' ? 'SG' : 'Unknown',
        region: country,
        source: 'server-side'
      };
    }
    
    // Check localStorage cache to avoid repeated API calls
    // Cache expires after 24 hours to respect rate limits
    const cacheKey = 'ip_location_cache';
    const cacheExpiryKey = 'ip_location_cache_expiry';
    let cachedData = localStorage.getItem(cacheKey);
    const cacheExpiry = localStorage.getItem(cacheExpiryKey);
    
    if (cachedData && cacheExpiry && Date.now() < parseInt(cacheExpiry)) {
      try {
        const result = JSON.parse(cachedData);
        const isSingapore = result.country === 'Singapore' || result.countryCode === 'SG';
        
        console.log('Using cached location data:', result.country);
        
        // Apply the appropriate shipping bar styles
        if (isSingapore) {
          $('.shipping-css').append(`<style>.singapore-free-shipping-bar { display: block; }</style>`);
        } else {
          $('.shipping-css').append(`<style>.singapore-free-shipping-bar { display: none; }</style>`);
        }
        
        return { ...result, source: 'cached' };
      } catch (e) {
        // Invalid cache, clear it and continue
        localStorage.removeItem(cacheKey);
        localStorage.removeItem(cacheExpiryKey);
        cachedData = null; // Clear the reference
      }
    }
    
    // Fallback to client-side detection if server-side is not available
    console.log('Server-side location not available, falling back to client-side detection');
    
    // Add timeout to prevent hanging requests
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 8000); // 8 second timeout
    
    // Try IP geolocation services
    let response;
    let data;
    
    try {
      // Try ip-api.com first (supports CORS, free tier: 45 req/min)
      response = await fetch('https://ip-api.com/json/?fields=status,message,country,countryCode,regionName,city,timezone', {
        signal: controller.signal,
        headers: {
          'Accept': 'application/json'
        }
      });
      
      // Handle rate limiting (HTTP 429)
      if (response.status === 429) {
        console.warn('ip-api.com rate limit exceeded, trying fallback service');
        throw new Error('Rate limit exceeded');
      }
      
      if (response.ok) {
        data = await response.json();
        
        // Check if API returned an error
        if (data.status === 'fail') {
          throw new Error(data.message || 'IP API returned an error');
        }
      } else {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    } catch (apiError) {
      // If ip-api.com fails, try ipapi.co as fallback (free tier: 1000/day)
      try {
        response = await fetch('https://ipapi.co/json/', {
          signal: controller.signal,
          headers: {
            'Accept': 'application/json'
          }
        });
        
        // Handle rate limiting (HTTP 429)
        if (response.status === 429) {
          console.warn('ipapi.co rate limit exceeded');
          throw new Error('Rate limit exceeded - all services unavailable');
        }
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        data = await response.json();
      } catch (fallbackError) {
        // If both APIs fail due to rate limits, use cached data if available
        if (cachedData) {
          console.log('API rate limited, using stale cache data');
          const result = JSON.parse(cachedData);
          const isSingapore = result.country === 'Singapore' || result.countryCode === 'SG';
          
          if (isSingapore) {
            $('.shipping-css').append(`<style>.singapore-free-shipping-bar { display: block; }</style>`);
          } else {
            $('.shipping-css').append(`<style>.singapore-free-shipping-bar { display: none; }</style>`);
          }
          return { ...result, source: 'stale-cache' };
        }
        throw new Error('All IP geolocation services failed');
      }
    }
    
    clearTimeout(timeoutId);
    
    // Validate that we have the expected data structure
    if (!data || typeof data !== 'object') {
      throw new Error('Invalid response format from IP API');
    }
    
    // Handle different API response formats
    const result = {
      country: data.country_name || data.country || 'Unknown',
      countryCode: data.country_code || data.countryCode || 'Unknown',
      region: data.region || data.regionName || 'Unknown',
      city: data.city || 'Unknown',
      timezone: data.timezone || 'Unknown',
      source: 'client-side'
    };

    // Cache the result for 24 hours to reduce API calls
    // This helps stay within free tier limits (ip-api.com: 45/min, ipapi.co: 1000/day)
    try {
      localStorage.setItem(cacheKey, JSON.stringify(result));
      localStorage.setItem(cacheExpiryKey, (Date.now() + (24 * 60 * 60 * 1000)).toString()); // 24 hours
    } catch (e) {
      // localStorage might be disabled, ignore
      console.warn('Could not cache location data:', e);
    }

    // Use the processed result for region detection
    const isSingapore = result.country === 'Singapore' || result.countryCode === 'SG';
    
    if (isSingapore) {
      // Singapore users - show Singapore content, hide others
      $('.shipping-css').append(`<style>.singapore-free-shipping-bar { display: block; }</style>`);
    } else {
      // Non-Singapore users - hide Singapore content only
      $('.shipping-css').append(`<style>.singapore-free-shipping-bar { display: none; }</style>`);
    }
    console.log('IP Location Detection Result:', isSingapore);
    return result;
  } catch (error) {
    if (error.name === 'AbortError') {
      console.log('IP location detection timed out');
    } else if (error.name === 'TypeError' && error.message.includes('fetch')) {
      console.log('IP location detection failed: Network error or CORS issue');
    } else {
      console.log('IP location detection failed:', error.message);
    }
    
    // If all detection methods fail, default to hiding Singapore content
    // This is a safe default that won't show restricted content to wrong users
    $('.shipping-css').append(`<style>.singapore-free-shipping-bar { display: none; }</style>`);
    return null;
  }
}

window.embroiderySectionInit = () =>{
  // Embroidery picker functionality
  const EmbroideryPicker = {
    init: function() {
      this.addonRadios = $('input[name="embroidery-addon"]');
      this.variantRadios = $('input[name="embroidery-variant"]');
      this.variantSection = $('.embroidery-second-section__option');
      this.positionSection = $('.embroidery-third-section__option');
      this.embroideryData = $('.jsc-embroidery-product-data');
      this.priceElement = $('.jsc-selected-embroidery-price');
      this.productForm = $('form[id*="product-form"]');
      this.lastSelectedPosition = null;
      
      if (this.addonRadios.length === 0) return;
      
      this.bindEvents();
      this.initializeState();
      console.log('Embroidery picker initialized successfully');
    },
    
    bindEvents: function() {
      // Addon radio change events
      this.addonRadios.on('change', $.proxy(this.handleAddonChange, this));
      
      // Variant radio change events
      this.variantRadios.on('change', $.proxy(this.handleVariantChange, this));
      
      // Position radio change events
      $('input[name="embroidery-position"]').on('change', $.proxy(this.handlePositionChange, this));
      
      // Product form events
      if (this.productForm.length) {
        this.productForm.on('variant:change', $.proxy(this.handleMainVariantChange, this));
        this.productForm.on('product:rerender', $.proxy(this.handleProductRerender, this));
      }
    },
    
    handleAddonChange: function() {
      const selectedValue = $('input[name="embroidery-addon"]:checked').val();
      
      if (selectedValue != 'no-addon') {
        this.variantSection.show();
        // Only show position section if a variant is selected
        if ($('input[name="embroidery-variant"]:checked').length > 0) {
          this.positionSection.show();
        } else {
          this.positionSection.hide();
        }
        this.restorePosition();
        setTimeout(() => this.scrollToBaseOverlayImage(), 100);
      } else {
        this.saveCurrentPosition();
        this.variantSection.hide();
        this.positionSection.hide();
      }
      
      this.updateSelectedStates();
      this.updateEmbroideryPrice();
      this.updateEmbroideryLogoOverlay();
    },
    
    handlePositionChange: function() {
      this.lastSelectedPosition = $('input[name="embroidery-position"]:checked').val();
      this.updateSelectedStates();
      this.updateEmbroideryLogoOverlay();
    },
    
    handleVariantChange: function() {
      console.log('Embroidery variant changed, updating overlay');
      
      // Show position section when variant is selected
      const selectedAddon = $('input[name="embroidery-addon"]:checked');
      if (selectedAddon.length && selectedAddon.val() == 'add-embroidery') {
        this.positionSection.show();
      }
      
      this.updateSelectedStates();
      this.updateEmbroideryPrice();
      this.updateEmbroideryLogoOverlay();
    },
    
    handleMainVariantChange: function() {
      console.log('Main product variant changed, resetting embroidery picker');
      const noAddonRadio = $('input[name="embroidery-addon"][value="no-addon"]');
      if (noAddonRadio.length) {
        noAddonRadio.prop('checked', true).trigger('change');
      }
    },
    
    handleProductRerender: function() {
      console.log('Product rerendered, reinitializing embroidery picker');
      setTimeout(() => this.init(), 100);
    },
    
    scrollToBaseOverlayImage: function() {
      const baseOverlayImage = $('img[alt="base-overlay-img"]');
      if (!baseOverlayImage.length) {
        console.log('Base overlay image not found. Add alt="base-overlay-img" to the image.');
        return;
      }
      
      const mediaContainer = baseOverlayImage.closest('.product-gallery__media');
      const carousel = mediaContainer.closest('scroll-carousel');
      
      if (!carousel.length) return;
      
      const mediaItems = carousel.find('.product-gallery__media');
      const targetIndex = mediaItems.index(mediaContainer);
      
      if (targetIndex === -1) return;
      
      // Try thumbnail navigation first
      const thumbnailButtons = window.innerWidth >= 820 
        ? $('.md\\:contents .product-gallery__thumbnail-list .scroll-marker')
        : $('.md\\:hidden .product-gallery__thumbnail-list .scroll-marker');
      
      if (thumbnailButtons.length > targetIndex) {
        const targetButton = thumbnailButtons.eq(targetIndex);
        if (targetButton.is(':visible')) {
          targetButton[0].click();
          return;
        }
      }
      
      // Fallback to scrolling
      const scrollContainer = carousel.find('.scroll-area');
      if (scrollContainer.length) {
        const itemWidth = mediaContainer.outerWidth();
        const scrollLeft = targetIndex * itemWidth;
        
        try {
          scrollContainer[0].scrollTo({
            left: scrollLeft,
            behavior: 'smooth'
          });
        } catch (error) {
          scrollContainer.scrollLeft(scrollLeft);
        }
      }
    },
    
    updateEmbroideryLogoOverlay: function() {
      const selectedAddon = $('input[name="embroidery-addon"]:checked');
      const selectedVariant = $('input[name="embroidery-variant"]:checked');
      const selectedPosition = $('input[name="embroidery-position"]:checked');
      
      console.log('Embroidery overlay - Addon:', selectedAddon.val(), 'Variant:', selectedVariant.length ? selectedVariant.val() : 'none', 'Position:', selectedPosition.length ? selectedPosition.val() : 'none');
      
      if (!selectedAddon.length || !selectedPosition.length) return;
      
      $('.embroidery-logo-overlay').remove();
      
      if (selectedAddon.val() == 'add-embroidery') {
        let logoImageUrl = null;
        
        // Get logo image from selected variant if available
        if (selectedVariant.length) {
          logoImageUrl = selectedVariant.attr('data-variant-image');
          console.log('Variant Image URL:', logoImageUrl);
        } else if (this.embroideryData.length) {
          // Fallback to embroidery data
          logoImageUrl = this.embroideryData.attr('embroidery-logo-img');
          console.log('Fallback Image URL:', logoImageUrl);
        }
        
        if (logoImageUrl) {
          console.log('Using image URL:', logoImageUrl);
          const baseOverlayImage = $('img[alt="base-overlay-img"]');
          const mediaContainer = baseOverlayImage.closest('.product-gallery__media');
          
          console.log('Base overlay image found:', baseOverlayImage.length);
          console.log('Media container found:', mediaContainer.length);
          
          if (mediaContainer.length) {
            // Get position code from the selected radio button
            const positionCode = selectedPosition.attr('data-position-code');
            console.log('Position code:', positionCode);
            
            // Create overlay with CSS class for positioning
            const overlayContainer = $(`<div class="embroidery-logo-overlay embroidery-logo-overlay--${positionCode.toLowerCase()}"></div>`);
            const overlayImage = $(`<img src="${logoImageUrl}" alt="Embroidery Logo Overlay">`);
            
            overlayContainer.append(overlayImage);
            mediaContainer.append(overlayContainer);
            console.log('Overlay created and appended');
          }
        } else {
          console.log('No image URL found');
        }
      }
    },
    
    updateEmbroideryPrice: function() {
      if (!this.priceElement.length) return;
      
      const selectedAddon = $('input[name="embroidery-addon"]:checked');
      const selectedVariant = $('input[name="embroidery-variant"]:checked');
      
      if (selectedAddon.length && selectedAddon.val() == 'add-embroidery') {
        let logoPrice = null;
        
        // Get price from selected variant if available
        if (selectedVariant.length) {
          logoPrice = selectedVariant.attr('data-variant-price');
        } else if (this.embroideryData.length) {
          // Fallback to embroidery data
          logoPrice = this.embroideryData.attr('embroidery-logo-price');
        }
        
        if (logoPrice) {
          const formattedPrice = (parseFloat(logoPrice) / 100).toFixed(2);
          this.priceElement.text(`(+$${formattedPrice})`);
        } else {
          this.priceElement.text('(+$0.00)');
        }
      } else {
        this.priceElement.text('(+$0.00)');
      }
    },
    
    saveCurrentPosition: function() {
      const selectedPositionRadio = $('input[name="embroidery-position"]:checked');
      if (selectedPositionRadio.length) {
        this.lastSelectedPosition = selectedPositionRadio.val();
      }
    },
    
    restorePosition: function() {
      if (this.lastSelectedPosition) {
        const positionRadio = $(`input[name="embroidery-position"][value="${this.lastSelectedPosition}"]`);
        if (positionRadio.length) {
          positionRadio.prop('checked', true);
        }
      } else {
        // Set default position (first available position)
        const firstPositionRadio = $('input[name="embroidery-position"]').first();
        if (firstPositionRadio.length) {
          firstPositionRadio.prop('checked', true);
        }
      }
    },
    
    updateSelectedStates: function() {
      // Update addon selection states
      this.addonRadios.each(function() {
        const $radio = $(this);
        const $label = $radio.closest('label');
        const $textSpan = $label.find('.embroidery-section__option-text');
        
        $textSpan.toggleClass('embroidery-section__option-text--selected', $radio.is(':checked'));
      });
      
      // Update variant selection states
      this.variantRadios.each(function() {
        const $radio = $(this);
        const $label = $radio.closest('label');
        const $textSpan = $label.find('.embroidery-section__option-text');
        
        $textSpan.toggleClass('embroidery-section__option-text--selected', $radio.is(':checked'));
      });
      
      // Update position selection states
      $('input[name="embroidery-position"]').each(function() {
        const $radio = $(this);
        const $label = $radio.closest('label');
        const $textSpan = $label.find('.embroidery-section__option-text');
        
        $textSpan.toggleClass('embroidery-section__option-text--selected', $radio.is(':checked'));
      });
    },
    
    initializeState: function() {
      // Initialize sections to correct state
      const selectedAddon = $('input[name="embroidery-addon"]:checked');
      if (selectedAddon.length && selectedAddon.val() == 'add-embroidery') {
        this.variantSection.show();
        // Only show position if variant is selected
        if ($('input[name="embroidery-variant"]:checked').length > 0) {
          this.positionSection.show();
        } else {
          this.positionSection.hide();
        }
      } else {
        this.variantSection.hide();
        this.positionSection.hide();
      }
      
      this.updateSelectedStates();
      this.updateEmbroideryPrice();
      this.updateEmbroideryLogoOverlay();
    }
  };
  
  // Initialize embroidery picker
  EmbroideryPicker.init();
}

window.jscNormalProdEmbroideryATC = (formID, mainProdVarID) => {

  if ($(".color-circle.active.disabled").length > 0) {
    $(".color-circle.active.disabled").parents('.bg-var-personalised').find('.error-message').addClass('active');
    setTimeout(function () {
      $(".color-circle.active.disabled").parents('.bg-var-personalised').find('.error-message').removeClass('active');
    }, 3000);
    return;
  }

  const button = document.querySelector(`button[form="${formID}"].jsc-normal-embroidery-addtocart`);
  if (button) {
    button.setAttribute('aria-busy', 'true');
  }

  let $embroiderySection = $(`.embroidery-section input[form='${formID}']`).closest('.embroidery-section');
  let $mainProdQty = parseInt($(`input[form='${formID}'].quantity-selector__input`).val());
  let $addonVarID = parseInt($(".jsc-embroidery-product-data").attr("embroidery-logo-varid"));
  let addonValue   = $embroiderySection.find("input[name='embroidery-addon']:checked").val();
  let variantValue = $embroiderySection.find("input[name='embroidery-variant']:checked").val();
  let positionValue = $embroiderySection.find("input[name='embroidery-position']:checked").val();
  let positionCode  = $embroiderySection.find("input[name='embroidery-position']:checked").data("position-code");
  
  // Debug: Log the selected values
  console.log('Add to Cart - Addon:', addonValue, 'Variant:', variantValue, 'Position:', positionValue);
  
  // Use selected variant ID if available, otherwise fall back to embroidery data
  if (variantValue) {
    $addonVarID = parseInt(variantValue);
  }

  let bindID = mainProdVarID+'-'+$addonVarID+'-'+positionCode;
  let preorderProperties = $('input[class="jsc-preorder-properties"]').val();
  console.log(bindID);

  if (typeof CartJS !== 'undefined') {
    let itemsToAdd = [];

    if ($(".personalised-prod").length > 0 && addonValue != 'add-embroidery') {
      let bindIDbpersonalize = mainProdVarID;
      let optionPersonalize = '';
      $($('.color-circle.active').get().reverse()).each(function () {
        optionPersonalize = optionPersonalize + $(this).parents('.bg-var-personalised.extra').find('.option-personalize-title').text() + $(this).parent().attr('data-col-title').replace(/-/g, ' ') + ',';
        bindIDbpersonalize = bindIDbpersonalize + '-' + $(this).parent().attr('data-variant-id');
      });
      $($('.color-circle.active').get().reverse()).each(function () {
        itemsToAdd.push({
          id: $(this).parent().attr('data-variant-id'),
          quantity: $mainProdQty,
          properties: {
            "_personalize_bundle_product": "child",
            "_personalize_bundle_bindID": bindIDbpersonalize,
            "_personalize_bundle_option": optionPersonalize,
          }
        });
      });

      if (preorderProperties == 'true') {
        itemsToAdd.push({
          id: mainProdVarID,
          quantity: $mainProdQty,
          properties: {
            "_personalize_bundle_product": "main",
            "_personalize_bundle_bindID": bindIDbpersonalize,
            "_personalize_bundle_option": optionPersonalize,
            "Backordered item(s) (Lead Time: 1.5 to 3 months)": "1",
          }
        });
      }
      else {
        itemsToAdd.push({
          id: mainProdVarID,
          quantity: $mainProdQty,
          properties: {
            "_personalize_bundle_product": "main",
            "_personalize_bundle_bindID": bindIDbpersonalize,
            "_personalize_bundle_option": optionPersonalize,
          }
        });
      }

    }
    else if ($(".personalised-prod").length > 0 && addonValue == 'add-embroidery' && positionCode && $addonVarID) {
      let bindIDbpersonalize = mainProdVarID;
      let optionPersonalize = '';
      $($('.color-circle.active').get().reverse()).each(function () {
        optionPersonalize = optionPersonalize + $(this).parents('.bg-var-personalised.extra').find('.option-personalize-title').text() + $(this).parent().attr('data-col-title').replace(/-/g, ' ') + ',';
        bindIDbpersonalize = bindIDbpersonalize + '-' + $(this).parent().attr('data-variant-id');
      });
      $($('.color-circle.active').get().reverse()).each(function () {
        itemsToAdd.push({
          id: $(this).parent().attr('data-variant-id'),
          quantity: $mainProdQty,
          properties: {
            "_personalize_bundle_product": "child",
            "_personalize_bundle_bindID": bindIDbpersonalize,
            "_personalize_bundle_option": optionPersonalize,
          }
        });
      });

      // Add embroidery addon if selected
      itemsToAdd.push({
        id: $addonVarID,
        quantity: $mainProdQty,
        properties: {
          "_embroidery_bundle_product": "child",
          "_embroidery_bundle_bindID": bindID,
          "_embroidery_position": positionValue,
          "_embroidery_position_code": positionCode
        }
      });

      if (preorderProperties  == 'true') {
        itemsToAdd.push({
          id: mainProdVarID,
          quantity: $mainProdQty,
          properties: {
            "_embroidery_bundle_product": "main",
            "_embroidery_bundle_bindID": bindID,
            "_personalize_bundle_product": "main",
            "_personalize_bundle_bindID": bindIDbpersonalize,
            "_personalize_bundle_option": optionPersonalize,
            "Backordered item(s) (Lead Time: 1.5 to 3 months)": "1",
          }
        });
        }
        else {
          itemsToAdd.push({
            id: mainProdVarID,
            quantity: $mainProdQty,
            properties: {
              "_embroidery_bundle_product": "main",
              "_embroidery_bundle_bindID": bindID,
              "_personalize_bundle_product": "main",
              "_personalize_bundle_bindID": bindIDbpersonalize,
              "_personalize_bundle_option": optionPersonalize,
            }
          });
        }
    }
    else if (addonValue == 'add-embroidery' && positionCode && $addonVarID) {
      // Add embroidery addon if selected
      itemsToAdd.push({
        id: $addonVarID,
        quantity: $mainProdQty,
        properties: {
          "_embroidery_bundle_product": "child",
          "_embroidery_bundle_bindID": bindID,
          "_embroidery_position": positionValue,
          "_embroidery_position_code": positionCode
        }
      });

      if (preorderProperties == 'true') {
        itemsToAdd.push({
          id: mainProdVarID,
          quantity: $mainProdQty,
          properties: {
            "_embroidery_bundle_product": "main",
            "_embroidery_bundle_bindID": bindID,
            "Backordered item(s) (Lead Time: 1.5 to 3 months)": "1",
          }
        });
      }
      else {
        itemsToAdd.push({
          id: mainProdVarID,
          quantity: $mainProdQty,
          properties: {
            "_embroidery_bundle_product": "main",
            "_embroidery_bundle_bindID": bindID,
          }
        }); 
      }
    }
    else if ($(".personalised-prod").length > 0) {
      let bindIDbpersonalize = mainProdVarID;
      let optionPersonalize = '';
      $($('.color-circle.active').get().reverse()).each(function () {
        optionPersonalize = optionPersonalize + $(this).parents('.bg-var-personalised.extra').find('.option-personalize-title').text() + $(this).parent().attr('data-col-title').replace(/-/g, ' ') + ',';
        bindIDbpersonalize = bindIDbpersonalize + '-' + $(this).parent().attr('data-variant-id');
      });
      $($('.color-circle.active').get().reverse()).each(function () {
        itemsToAdd.push({
          id: $(this).parent().attr('data-variant-id'),
          quantity: $mainProdQty,
          properties: {
            "_personalize_bundle_product": "child",
            "_personalize_bundle_bindID": bindIDbpersonalize,
            "_personalize_bundle_option": optionPersonalize,
          }
        });
      });

      if (preorderProperties == 'true') {
        itemsToAdd.push({
          id: mainProdVarID,
          quantity: $mainProdQty,
          properties: {
            "_personalize_bundle_product": "main",
            "_personalize_bundle_bindID": bindIDbpersonalize,
            "_personalize_bundle_option": optionPersonalize,
            "Backordered item(s) (Lead Time: 1.5 to 3 months)": "1",
          }
        });
      }else {
        itemsToAdd.push({
          id: mainProdVarID,
          quantity: $mainProdQty,
          properties: {
            "_personalize_bundle_product": "main",
            "_personalize_bundle_bindID": bindIDbpersonalize,
            "_personalize_bundle_option": optionPersonalize,
          }
        }); 
      }

    }
    else {
      if (preorderProperties == 'true') {
        itemsToAdd.push({
          id: mainProdVarID,
          quantity: $mainProdQty,
          properties: {
            "Backordered item(s) (Lead Time: 1.5 to 3 months)": "1",
          }
        });
      }else { 
        itemsToAdd.push({
          id: mainProdVarID,
          quantity: $mainProdQty,
          properties: {}
        });
      }
    }

    console.log("ItemToAdd", itemsToAdd);
    
    // Add items to cart
    if (itemsToAdd.length > 0) {
      CartJS.addItems(itemsToAdd, {
        success: function(data) {
          console.log('Items added to cart:', data);
          if (button) {
            button.removeAttribute('aria-busy');
          }
          fetchCartWithSections();
        },
        error: function(jqXHR, textStatus, errorThrown) {
          console.error('Error adding to cart:', errorThrown, jqXHR);
          if (button) {
            button.removeAttribute('aria-busy');
          }
        }
      });
    }
  } else {
    console.error('Cart.js not loaded');
    if (button) {
      button.removeAttribute('aria-busy');
    }
  }
}
// Function to fetch cart with sections for proper cart drawer updates
window.fetchCartWithSections = async function() {
  try {
    const currentCart = CartJS.cart;
    if (!currentCart) {
      console.error('No cart data available from CartJS');
      return;
    }
    
    const cartDrawerElement = document.querySelector('cart-drawer');
    if (!cartDrawerElement) return;
    
    let sectionId = cartDrawerElement.getAttribute('data-section-id');
    if (!sectionId) {
      const parentSection = cartDrawerElement.closest('[id^="shopify-section-"]');
      if (parentSection) {
        sectionId = parentSection.id.replace('shopify-section-', '');
      }
    }
    
    console.log('Using section ID:', sectionId);
    
    // Fetch cart with sections
    const response = await fetch(`${Shopify.routes.root}?section_id=${sectionId}`);
    const html = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    
    // Get the full section HTML, not just the cart-drawer element
    const sectionElement = doc.querySelector(`#shopify-section-${sectionId}`);
    
    if (sectionElement) {
      // Create cart object with existing cart data + sections
      const cartWithSections = {
        ...currentCart,
        sections: {
          [sectionId]: sectionElement.outerHTML
        }
      };
      
      // Dispatch cart:change with preserved cart details + sections
      document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          baseEvent: "variant:add",
          cart: cartWithSections
        }
      }));
    } else {
      console.error('Could not find section element with ID:', sectionId);
      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
    }
  } catch (error) {
    console.error('Error fetching cart with sections:', error);
    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
  }
};
// Embroidery Logo Management Functions
window.addEmbroidery = () => {
  console.log("Adding embroidery logos", $('.jsc-add-embroidery').length);
  if ($('.jsc-add-embroidery').length > 0) {
    $('.jsc-add-embroidery').each(function() {
      console.log("Adding embroidery logo");
      const varID = $(this).val();
      const varQty = parseInt($(this).attr('data-quantity')) || 1;

      let properties = $(this).attr('data-properties');
      let propsObj = {};
      if (properties) {
        try {
          propsObj = JSON.parse(properties);
        } catch (e) {
          console.warn('Invalid data-properties JSON', e);
        }
      }

      CartJS.addItem(varID, varQty, propsObj,
      {
        // Define a success callback to display a success message.
        "success": function(data, textStatus, jqXHR) {
          console.log('Added item to cart');
        },
        // Define an error callback to display an error message.
        "error": function(jqXHR, textStatus, errorThrown) {
          console.log("Error occur !", errorThrown, jqXHR);
        }
      });
      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
    });
  }
}
window.removeEmbroidery = () => {
  if ($('.jsc-remove-embroidery').length > 0) {
    var jsonObj = {};
    $('.jsc-remove-embroidery').each(function(){
      var varID = $(this).val();
      jsonObj[varID] = 0;
    });
    CartJS.updateItemQuantitiesById(jsonObj);
  }
}
window.updateEmbroidery = () => {
  if ($('.jsc-update-embroidery').length > 0) {
    $('.jsc-update-embroidery').each(function(){
      var varID = $(this).val();
      var QTY = parseInt($(this).attr('data-quantity'));
      CartJS.updateItemById(varID, QTY);
    });
  }
}
window.removeEmbroideryItem = (itemKey) => {
  CartJS.updateItemById(itemKey, 0);
}

// GWP Management Functions
window.addGwp = () => {
  console.log("Adding GWP items", $('.jsc-add-gwp').length);
  if ($('.jsc-add-gwp').length > 0) {
    $('.jsc-add-gwp').each(function() {
      console.log("Adding GWP item");
      const varID = $(this).val();
      const varQty = parseInt($(this).attr('data-quantity')) || 1;

      let properties = $(this).attr('data-properties');
      let propsObj = {};
      if (properties) {
        try {
          propsObj = JSON.parse(properties);
        } catch (e) {
          console.warn('Invalid data-properties JSON', e);
        }
      }

      CartJS.addItem(varID, varQty, propsObj,
      {
        // Define a success callback to display a success message.
        "success": function(data, textStatus, jqXHR) {
          console.log('GWP item added to cart');
          fetchCartWithSections();
        },
        // Define an error callback to display an error message.
        "error": function(jqXHR, textStatus, errorThrown) {
          console.log("Error occur !", errorThrown, jqXHR);
        }
      });
    });
  }
}

window.removeGwp = () => {
  if ($('.jsc-remove-gwp').length > 0) {
    var jsonObj = {};
    $('.jsc-remove-gwp').each(function(){
      var itemKey = $(this).val();
      jsonObj[itemKey] = 0;
    });
    CartJS.updateItemQuantitiesById(jsonObj, {
      success: function(data) {
        console.log('Items remove from cart:', data);
        fetchCartWithSections();
      },
      error: function(jqXHR, textStatus, errorThrown) {
        console.error('Error remove from cart:', errorThrown, jqXHR);
      }
    });
  }
}

window.updateGwp = () => {
  console.log("Updating GWP items", $('.jsc-update-gwp').length);
  var updates = {};

  if ($('.jsc-update-gwp').length > 0) {
    $('.jsc-update-gwp').each(function() {
      var itemKey = $(this).val();
      var QTY = parseInt($(this).attr('data-quantity'), 10);
      updates[itemKey] = QTY;
    });

    // Check if there are any items to update.
    if (Object.keys(updates).length > 0) {
      CartJS.updateItemQuantitiesById(updates, {
        success: function(data) {
          console.log('Successfully updated GWP items:', data);
          fetchCartWithSections();
        },
        error: function(jqXHR, textStatus, errorThrown) {
          console.error('Error updating GWP items:', errorThrown, jqXHR);
        }
      });
    }
  }
}

window.removeExcessGwp = () => {
  if ($('.jsc-remove-excess-gwp').length > 0) {
    $('.jsc-remove-excess-gwp').each(function(){
      var itemKeys = $(this).val().split(',');
      var keepQuantity = parseInt($(this).attr('data-keep-quantity')) || 0;
      
      for (var i = 0; i < itemKeys.length; i++) {
        var itemKey = itemKeys[i].trim();
        if (itemKey) {
          if (keepQuantity === 0 || i >= keepQuantity) {
            CartJS.updateItemById(itemKey, 0, {
              success: function(data) {
                console.log(`Successfully removed GWP item with key: ${itemKey}`, data);
                fetchCartWithSections();
              },
              error: function(jqXHR, textStatus, errorThrown) {
                console.error(`Error removing GWP item with key: ${itemKey}`, errorThrown, jqXHR);
              }
            });
          }
        }
      }
    });
  }
}

window.removeGwpItem = (itemKey) => {
  CartJS.updateItemById(itemKey, 0, {
    success: function(data) {
      console.log(`Successfully removed GWP item with key: ${itemKey}`, data);
      fetchCartWithSections();
    },
    error: function(jqXHR, textStatus, errorThrown) {
      console.error(`Error removing GWP item with key: ${itemKey}`, errorThrown, jqXHR);
    }
  });
}
// Custom main-cart refresh function
window.refreshMainCart = async function() {
  if (window.themeVariables && window.themeVariables.settings.pageType === "cart") {
    try {
      console.log('Refreshing main cart page...');
      $('.jsc-page-loading').show();
      
      // Fetch the current cart page content
      const response = await fetch(window.location.href);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      // Replace the main cart content
      const newCartContent = doc.querySelector('.shopify-section--main-cart');
      const currentCartContent = document.querySelector('.shopify-section--main-cart');
      
      if (newCartContent && currentCartContent) {
        // Preserve any custom event listeners by replacing innerHTML
        currentCartContent.innerHTML = newCartContent.innerHTML;
        
        // Re-initialize any custom elements that might have been replaced
        if (window.customElements) {
          // Re-register any custom elements that might need re-initialization
          const customElements = currentCartContent.querySelectorAll('cart-note, line-item, quantity-selector');
          customElements.forEach(element => {
            if (element.connectedCallback) {
              element.connectedCallback();
            }
          });
        }
        
        console.log('Main cart refreshed successfully');
      } else {
        console.warn('Could not find cart content to refresh, falling back to page reload');
        window.location.reload();
      }
    } catch (error) {
      console.error('Error refreshing main cart:', error);
      // Fallback to page reload
      window.location.reload();
    } finally {
      $('.jsc-page-loading').hide();
    }
  }
};
window.masterPromo = () => {
  console.log('Init master promo');
  $(document).off('cart.requestStarted');
  $(document).off('cart.requestComplete');
  $(document).on('cart.requestStarted', function(event, cart) {
    console.log('cart.requestStarted fired');
    $('.jsc-page-loading').show();
  });
  $(document).on('cart.requestComplete', function(event, cart) {
    console.log('cart.requestComplete fired');
    // Check if cart has sections data (needed for cart drawer)
    $('.jsc-page-loading').hide();
    if (cart && cart.sections) {
      document.documentElement.dispatchEvent(new CustomEvent("cart:change", { 
        bubbles: true,
        detail: {
          baseEvent: "variant:add",
          cart: cart
        }
      }));
    } else {
      console.log('cart:refresh');
      if (window.themeVariables && window.themeVariables.settings.pageType === "cart") {
        window.refreshMainCart();
      } else {
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
      } 
    }
  });
  addEmbroidery();
  removeEmbroidery();
  updateEmbroidery();
  removeGwp();
  removeExcessGwp();
  updateGwp();
  addGwp();
}
window.toggleAddons = (event, addOnClass) => {
  // Use toggleClass() to add or remove the 'hide' class
  console.log("addOnClass",addOnClass);
  $(`.${addOnClass}`).toggleClass('hide');
}
// Start - Product Personalised
window.toggledropdown = (evt) => {
    $(evt).parents('.bg-var-personalised').find('.variant-picker__option-values').toggle();
    $(evt).parents('.bg-var-personalised').find('.swatch-container').toggle();
    $(evt).toggleClass('active');
}
window.swappersonalizecol = (evt) => {
    setTimeout(function () {
        $(evt).parents('.swatch-container').find('.color-circle').removeClass('active');
        $(evt).parents('.color-item').find('.color-circle').addClass('active');
        var loop = $(evt).parents('.color-item').attr('data-loop');
        var overlayimg = $(evt).parents('.color-item').attr('data-img-overlay');
        var pricemoney = $(evt).parents('.color-item').attr('data-price-money');
        var mainprodprice = 0;
        var addonprodprice = 0;
        $(evt).parents('.product').find(".color-circle.active").each(function () {
            addonprodprice = addonprodprice + parseInt($(this).parents('.color-item').attr('data-price'));
        });
        $(evt).parents('.product').find(".variant-list-data").each(function () {
            var datavarid = $(this).val();
            if (datavarid == $(evt).parents('.product').find('.selected-variant').val()) {
              mainprodprice = parseInt($(this).attr('data-price')) + addonprodprice;
            }
        });
        mainprodprice = (mainprodprice / 100).toFixed(2);
        $(evt).parents('.product').find('.prod-price .money').text(`$${mainprodprice}`);
        if (pricemoney) {
            var cleanPrice = $('<div>').html(pricemoney).text();
            $(evt).parents('.bg-var-personalised.extra').find('.varpricePersonalize').text('(+ '+cleanPrice+')');
        }else{
            $(evt).parents('.bg-var-personalised.extra').find('.varpricePersonalize').text('');
        }
        $(evt).parents('.bg-var-personalised.extra').find('.col-title').text($(evt).parents('.color-item').attr('data-col-title').replace(/-/g, ' '));
        $('.img-overlay-personalized-'+loop).attr('src',overlayimg);
    }, 10);
}
window.swapprodvar = () => {
    if ($('.product').find(".color-circle.active").length > 0) {
        var mainprodprice = 0;
        var addonprodprice = 0;
        $('.product').find(".color-circle.active").each(function () {
            addonprodprice = addonprodprice + parseInt($(this).parents('.color-item').attr('data-price'));
        });
        $('.product').find(".variant-list-data").each(function () {
            var datavarid = $(this).val();
            if (datavarid == $('.product').find('.selected-variant').val()) {
            mainprodprice = parseInt($(this).attr('data-price')) + addonprodprice;
            }
        });
        mainprodprice = (mainprodprice / 100).toFixed(2);
        $('.product').find('.prod-price .money').text(`$${mainprodprice}`);
    }
}
window.toggleTabColor = (evt) => {
  $(evt).parents('.tab-container-color').find('.tab-color-item').removeClass('active');
  $(evt).addClass('active');
  var productcol = $(evt).attr('data-tab-color');
  $(evt).parents('.bg-var-personalised').find('.tab-content-color').removeClass('active');
  $(evt).parents('.bg-var-personalised').find('.tab-content-color[data-tab-content="'+productcol+'"]').addClass('active');
  $(evt).parents('.bg-var-personalised').find('.tab-content-color').find('.color-circle').removeClass('active');
  $(evt).parents('.bg-var-personalised').find('.tab-content-color[data-tab-content="'+productcol+'"]').find('.color-circle')[0].click();
}
window.onclickcolor = () => {
  $(".bg-var-personalised.extra").each(function () {
    $(this).find('.tab-content-color.active').find('.color-circle.active')[0].click();
  });
}
window.removeBundleItem = (bundleKeylist) => {
  var keysplit = bundleKeylist.split(",");
  var jsonObj = {};
  for (let i=0;i<keysplit.length;i++){
      jsonObj[keysplit[i]] = 0;
  }
  CartJS.updateItemQuantitiesById(jsonObj, {
    success: function(data) {
      console.log('Items remove from cart:', data);
      fetchCartWithSections();
    },
    error: function(jqXHR, textStatus, errorThrown) {
      console.error('Error remove from cart:', errorThrown, jqXHR);
    }
  });
}
window.updateBundleItemQuantity = (bundleKeylist, quantity) => {
  var keysplit = bundleKeylist.split(",");
  var jsonObj = {};
  for (let i=0;i<keysplit.length;i++){
    jsonObj[keysplit[i]] = quantity;
  }
  console.log("test", jsonObj);
  CartJS.updateItemQuantitiesById(jsonObj, {
    success: function(data) {
      console.log('Items update quantity from cart:', data);
      fetchCartWithSections();
    },
  });
}
// End - Product Personalised
// Start - Custom scripts for Amai PreOrder Manager + Notify app
const triggerPreOrderButton = () => {
  $('.spurit-po-wrapper').on('click', function(e) {
    const $button = $(this).find('button[type="submit"]');

    // Prevent double triggering if user clicked the button directly
    if (!$(e.target).is($button)) {
      $button.trigger('click');
    }
  });
}
// End - Custom scripts for Amai PreOrder Manager + Notify app


// start:: cart drawer upsell section
window.cartUpsellSelection = (el) => {
  var selectedSize = $(el).find(':selected').data('size');
    var selectedVarId = $(el).find(':selected').val();
    var selectedVarAvailable = $(el).find(':selected').data('available');
    var selectedVarDimension = $(el).find(':selected').data('dimension');
    $('#selected-size').text(selectedSize);
    var $atc_button = $('.jsc-upsell-atc-section');
    $atc_button.attr('data-id',selectedVarId);
    $atc_button.attr('data-available',selectedVarAvailable);
    $atc_button.attr('data-dimension',selectedVarDimension);

    //console.log('this variant',selectedVarId);

    if (selectedVarAvailable == true) {
      // console.log('add this variant',selectedVarId);
      $atc_button.addClass('cursor');
      $atc_button.find('.jsc-upsell-button').text('Add to cart');
    } else {
      // console.log('dont add this variant',selectedVarId);
      $atc_button.removeClass('cursor');
      $atc_button.find('.jsc-upsell-button').text('Sold Out');
    }
}

window.addUpsell = (e) => {
  var varID = $(e).data('id');
  var varAvail = $(e).data('available');
  var varQty = 1;
  var propsObj = {};
  var varDimension = $(e).data('dimension');
  // console.log('clickkkk',varID);

  if (varAvail == true) {
    propsObj['_upsell_item'] = true;
    if (varDimension != '') {
      propsObj['_dimension'] = varDimension;
    }
    console.log('add this variant',varID);
    CartJS.addItem(varID, varQty, propsObj,
      {
        // Define a success callback to display a success message.
        "success": function(data, textStatus, jqXHR) {
          console.log('Added item to cart');
        },
        // Define an error callback to display an error message.
        "error": function(jqXHR, textStatus, errorThrown) {
          console.log("Error occur !", errorThrown, jqXHR);
        }
      });
      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
  }
}
// end:: cart drawer upsell section